// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bdeaa882","455":"9ed5040f","977":"1f1a2f25"}[chunkId] + ".chunk.js";
};